let { defaultState } = require('./state.js')

export default {
    reset: (state) => {
        Object.assign(state, defaultState())
    },
    resume(state, payload) {
        Object.assign(state, payload)
    },
    setBundle: (state, payload) => {
        state.bundle = payload
    },
    select: (state, payload) => {
        state.bundle.filter(item => item.type === payload.type).forEach(item => { item.selected = false })
        let items = state.bundle.filter(item => (payload.data.includes(item.name) && item.type === payload.type))
        items.forEach(item => { item.selected = true })
    },
    updateCareplanShownList: (state, payload) => {
        const noneSelected = payload.length === 0
        // payload is a list of assessment names that have been selected
        const items = state.bundle.filter(item => item.type === 'plan')
        items.forEach(item => {
            if (item.display_hidden) {
                item.shown = false;
                item.selected = false;
                return;
            }
            item.shown = payload.includes(item.assessment) || noneSelected
        })
    }
}
